/**
 * @author Harshitha.k
 * @description 
 */

import { Input, Tag } from 'antd';
import React, { useState, useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';

const TagInputWidget = (props) => {
  const [inputTagVisible, setInputTagVisible] = useState(false);
  const [tagList, setTagList] = useState(props.value);

  useEffect(() => {
    setTagList(props.value || []);
  }, [props.value]);

  const handleTagClick = () => {
    setInputTagVisible(!inputTagVisible);
  };


  const handleInputEnter = (e) => {
      const newTagList = [...tagList, e.target.value];
      setInputTagVisible(!inputTagVisible);
      props.addedTagList(newTagList);
  };

  const handleTagClose = (index) => {
    const newValue = [...tagList];
    newValue.splice(index, 1);
    setTagList(newValue);
    setInputTagVisible(!inputTagVisible);
    props.addedTagList(newValue);
  };

  return (
    <div>
      <Tag
        onClick={handleTagClick}
        style={{ borderStyle: 'dashed' }}
      >
        <PlusOutlined /> New Tag
      </Tag>

      {inputTagVisible && (
        <Input
          type="text"
          onPressEnter={handleInputEnter}
          // onBlur={() => setInputTagVisible(false)} // Optional: Hide input on blur
        />
      )}

      {tagList && Array.isArray(tagList) && tagList.map((tag, index) => {
        const isLongTag = tag.length > 20;
        return (
          <Tag
            key={tag}
            closable={true}
            onClose={() => handleTagClose(index)}
          >
            {isLongTag ? `${tag.slice(0, 20)}...` : tag}
          </Tag>
        );
      })}
    </div>
  );
};

export default TagInputWidget;